import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ModalNext, ModalHeader, ModalBody, ModalFooter } from '@jutro/components';
import { ServiceManager } from '@jutro/legacy/services';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelUtil } from '@xengage/gw-portals-viewmodel-js';
import { PremierConstants } from 'premier-constant-service';
import generateSubComponents from './ScheduleItemTypes/ScheduleItemTypes';
import messages from './ScheduleItemsComponent.messages';

import { Button } from '@jutro/legacy/components';

function ScheduleItemModalPopover(props) {
    const {
        propertyInfo,
        viewModelService,
        scheduleData,
        scheduleItem,
        labelPosition,
        id,
        isNew,
        isOpen,
        onResolve,
        onReject,
        bodyAutoFocus,
        phoneWide
    } = props;
    const translator = useTranslator();
    const localeService = ServiceManager.getService('locale-service');
    const [modalData, setModalData] = useState(scheduleData);
    const { isComponentValid, onValidate } = useValidation(id);
    const { common } = PremierConstants;

    const modalOverrides = {
        '@field': {
            labelPosition,
            phoneWide,
            showOptional: false,
            showRequired: true
        }
    };

    const handleChange = useCallback(
        (value, path) => {
            
            
            const clonedData = _.cloneDeep(modalData);
            const newPath = ViewModelUtil.getNonVMPath(path);
            
            _.set(clonedData, newPath, value);

            if(id.indexOf(common.PLEProCovCov) !== -1 
                || id.indexOf(common.PPLArcMisProFloCov) !== -1
                || id.indexOf(common.PPLAccMisProFloCov) !== -1
                || id.indexOf(common.PPLMipMisProFloCov) !== -1) {
                if(path === 'itemData.Limit.bigDecimalValue' && value > 0 
                && _.isUndefined(clonedData.itemData.Deductible)) {
                    _.set(clonedData, 'itemData.Deductible.typeCodeValue', '1000')
                }
                
            }

           if (id.indexOf(common.PSWMisProFloCov) !== -1 && path === 'itemData.Item.typeCodeValue') {
                const mappedscheduleItem = scheduleItem.propertyInfos
                        .filter((typeCode) => typeCode.label === 'Item')[0].availableTypeListValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.displayKey,
                                defaultMessage: typeCode.displayKey
                            })
                        }))
                const DescVal = mappedscheduleItem.filter((itemVal) => itemVal.code === clonedData.itemData.Item.typeCodeValue)     
                const desName = {'stringValue':  DescVal[0].name};

                _.set(clonedData, 'itemData.Description', desName)
           }

           if (_.isUndefined(modalData.itemData.BasisofSettlement)) {
                const basisofSettlementVal = {'typeCodeValue':  'ActCasVal'};
                
                _.set(clonedData, 'itemData.BasisofSettlement', basisofSettlementVal)
           }
            
            setModalData(clonedData);
        },
        [id, modalData]
    );

    const orderedPropertyInfo = useMemo(() => _.sortBy(propertyInfo, 'order'), [propertyInfo]);
    const defaultCountryCode = localeService.getDefaultCountryCode();
    const subComponents = orderedPropertyInfo.flatMap((info) => generateSubComponents({
        info,
        modalData,
        viewModelService,
        translator,
        defaultCountryCode,
        scheduleItem,
        onValueChange: handleChange,
        onValidate,
        parentOverrides: modalOverrides,
        isNew
    }));

    const handleAdd = useCallback(() => {
        onResolve(modalData);
    }, [onResolve, modalData]);

    const modalOkLabel = useMemo(() => {
        return isNew ? messages.scheduleAdd : messages.save;
    }, [isNew]);

    return (
        <ModalNext
            isOpen={isOpen}
        >
            <ModalHeader
                title={scheduleItem.displayName}
            />
            <ModalBody
                contentLayout={{
                    component: 'grid'
                }}
                autoFocus={bodyAutoFocus}
            >
                {subComponents}
            </ModalBody>
            <ModalFooter>
                <Button onClick={onReject} type="outlined">
                    {messages.scheduleCancel}
                </Button>
                <Button onClick={handleAdd} disabled={!isComponentValid}>
                    {modalOkLabel}
                </Button>
            </ModalFooter>
        </ModalNext>
    );
}

ScheduleItemModalPopover.propTypes = {
    propertyInfo: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    scheduleData: PropTypes.shape({}),
    phoneWide: PropTypes.shape({}),
    labelPosition: PropTypes.string,
    id: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onResolve: PropTypes.func,
    scheduleItem: PropTypes.shape({
        displayName: PropTypes.string
    }).isRequired,
    viewModelService: PropTypes.shape({}).isRequired,
    isNew: PropTypes.bool.isRequired,
    bodyAutoFocus: PropTypes.string,
    onReject: PropTypes.func
};
ScheduleItemModalPopover.defaultProps = {
    scheduleData: {},
    labelPosition: 'left',
    onResolve: undefined,
    phoneWide: {
        labelPosition: 'top'
    },
    bodyAutoFocus: '',
    onReject: undefined
};
export default ScheduleItemModalPopover;
